import Vue from "vue";
import VueRouter from "vue-router";
// import store from "../store/index";
import HomeView from "../views/HomeView.vue";
import LoginPage from "../views/Login.vue";
import RegisterPage from "../views/Register.vue";
import LoadingLayout from "../views/LoadingLayout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home-page",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login-page",
    component: LoginPage,
    meta: { notAuth: true },
  },
  {
    path: "/register",
    name: "register-page",
    component: RegisterPage,
    meta: { notAuth: true },
  },
  {
    path: "/loading-game/:provider/:game",
    name: "loadinggame",
    component: LoadingLayout,
    meta: { notAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (store.getters.Auth.loggedIn) {
//       next();
//       return;
//     }
//     next("/login");
//   } else {
//     next();
//   }
// });

// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.notAuth)) {
//     if (!store.getters.Auth.loggedIn) {
//       next();
//       return;
//     }
//     next("/");
//   } else {
//     next();
//   }
// });

export default router;
